"use strict";

exports.__esModule = true;
exports.default = getInitialPopperStyles;
function getInitialPopperStyles() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'absolute';
  return {
    position: position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
}